class BackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-back-in-stock-external-el="trigger"]',
    )
    if (!trigger) return

    await window.BAO.sectionRenderer
      .fetchSingle('back-in-stock', trigger.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const bodyContent = newDOM.querySelector('.shopify-section')

        this.els.body.element.innerHTML = bodyContent.outerHTML

        window.drawers.activeDrawerKey = 'back-in-stock'
      })
      .catch(() => {
        window.drawers.activeDrawerKey = ''
      })
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
